/**
 * Leitura da resposta da API.
 *
 * Os endpoints públicos usados pela landingpage (`POST /contato`, `PUT /contato`)
 * respondem `{ type: 'success' | 'warning', data: <payload> }`, onde `data` no caso
 * do contato é a STRING do uuid.
 *
 * A leitura anterior — `res?.data?.uuid || res?.data?.data?.uuid` — tentava tolerar
 * duas formas e não acertava nenhuma: `res.data.data` é a string, e `.uuid` dela é
 * sempre `undefined`. O `if (uuid)` nunca entrava, então `trackLeadCriado()` e
 * `trackQuizCompleto()` nunca foram chamados: 0 eventos `lead_criado` em 8.418
 * sessões, e a taxa de conversão do dashboard travada em 0%.
 *
 * Por isso a leitura mora num lugar só.
 */

/**
 * Payload de uma resposta bem-sucedida, ou null.
 * Aceita tanto `{ type, data }` quanto um corpo que já é o payload.
 */
export function dadosDaResposta(res) {
  const corpo = res && res.data;

  if (!corpo) return null;
  if (corpo.type && corpo.type !== 'success') return null;

  return corpo.data !== undefined ? corpo.data : corpo;
}

/**
 * UUID de uma resposta de criação. `data` pode ser a string do uuid
 * (é o caso de `POST /contato`) ou um objeto que o carrega.
 */
export function uuidDaResposta(res) {
  const dados = dadosDaResposta(res);

  if (!dados) return null;
  if (typeof dados === 'string') return dados || null;

  return dados.uuid || null;
}
